import {CancelBottomSheetComponent} from './cancel-bottom-sheet/cancel-bottom-sheet.component';
import {CommonModule} from '@angular/common';
import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {ColorPickerComponent} from './color-picker/color-picker.component';
import {TradeInInfoComponent} from './trade-in-info/trade-in-info.component';
import {InlineSVGModule} from 'ng-inline-svg-2';
import {ToggleLocationComponent} from './toggle-location/toggle-location.component';
import {MaterialModule} from '../../shared/modules/material-module';
import {CustomerInfoComponent} from './customer-info/customer-info.component';
import {ReactiveFormsModule} from '@angular/forms';
import {ConfirmationComponent} from './confirmation/confirmation.component';
import {CalendarHeaderComponent} from './calendar/calendar-header/calendar-header.component';
import {SharedModule} from '../../shared/shared.module';
import {VehicleConfiguratorComponent} from './vehicle-configurator/vehicle-configurator.component';
import {VehicleDetailsComponent} from './vehicle-details/vehicle-details.component';
import { ServiceHistoryComponent } from './service-history/service-history.component';
import { SelectVehicleComponent } from './select-vehicle/select-vehicle.component';
import { VehicleCardComponent } from './select-vehicle/vehicle-card/vehicle-card.component';
import { SelectLearningVehicleComponent } from './select-learning-vehicle/select-learning-vehicle.component';
import { LearningVehicleCardComponent } from './select-learning-vehicle/learning-vehicle-card/learning-vehicle-card.component';
import { ContactEmailInfoComponent } from './contact-email-info/contact-email-info.component';
import { AvailabilityTimeComponent } from './availability-time/availability-time.component';
import { ChecklistComponent } from './checklist/checklist.component';
import { ConfirmSummaryComponent } from './confirm-summary/confirm-summary.component';
import { ConfirmedSummaryInfoComponent } from './confirmed-summary-info/confirmed-summary-info.component';
import { CustomerDialogComponent } from './customer-dialog/customer-dialog.component';

@NgModule({
  declarations: [
    ConfirmationComponent,
    CancelBottomSheetComponent,
    ToggleLocationComponent,
    TradeInInfoComponent,
    CustomerInfoComponent,
    ColorPickerComponent,
    CalendarHeaderComponent,
    VehicleConfiguratorComponent,
    ServiceHistoryComponent,
    VehicleDetailsComponent,
    SelectVehicleComponent,
    VehicleCardComponent,
    SelectLearningVehicleComponent,
    LearningVehicleCardComponent,
    ContactEmailInfoComponent,
    AvailabilityTimeComponent,
    ChecklistComponent,
    ConfirmSummaryComponent,
    ConfirmedSummaryInfoComponent,
    CustomerDialogComponent
  ],
  exports: [
    MaterialModule,
    CommonModule,
    InlineSVGModule,
    ConfirmationComponent,
    ToggleLocationComponent,
    TradeInInfoComponent,
    CustomerInfoComponent,
    ReactiveFormsModule,
    ColorPickerComponent,
    VehicleConfiguratorComponent,
    ServiceHistoryComponent,
    VehicleDetailsComponent,
    SelectVehicleComponent,
    VehicleCardComponent,
    SelectLearningVehicleComponent,
    LearningVehicleCardComponent,
    ContactEmailInfoComponent,
    AvailabilityTimeComponent,
    ChecklistComponent,
    ConfirmSummaryComponent,
    ConfirmedSummaryInfoComponent,
    CustomerDialogComponent
  ],
  imports: [
    CommonModule,
    InlineSVGModule.forRoot(),
    ReactiveFormsModule,
    SharedModule
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BdcSharedModule {
}
